import React from "react";

// Decoracions estil collage / paper retallat, paleta Karamiko

export const PineTree = ({ className = "", style }) => (
  <svg viewBox="0 0 24 48" className={className} style={style} fill="none" aria-hidden="true">
    <line x1="12" y1="2" x2="12" y2="46" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
    {[8, 15, 22, 29, 36].map((y, i) => (
      <g key={i}>
        <line x1="12" y1={y} x2={5} y2={y + 5} stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
        <line x1="12" y1={y} x2={19} y2={y + 5} stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
      </g>
    ))}
  </svg>
);

export const LeafShape = ({ className = "", style }) => (
  <svg viewBox="0 0 40 46" className={className} style={style} aria-hidden="true">
    {/* tija */}
    <path d="M20 45 C20 38 20 34 20 31" stroke="currentColor" strokeWidth="2" strokeLinecap="round" fill="none" />
    {/* limbe */}
    <path d="M20 2 C33 11 33 25 20 32 C7 25 7 11 20 2 Z" fill="currentColor" />
    {/* nervadures */}
    <g stroke="#faf7f2" strokeWidth="1.3" strokeLinecap="round" fill="none" opacity="0.75">
      <path d="M20 30 L20 6" />
      <path d="M20 12 L12 9" /><path d="M20 12 L28 9" />
      <path d="M20 18 L11 16" /><path d="M20 18 L29 16" />
      <path d="M20 24 L13 23" /><path d="M20 24 L27 23" />
    </g>
  </svg>
);

// Cara de mico del logo (silueta) en paper retallat
export const MonkeyHead = ({ className = "", style }) => (
  <svg viewBox="0 0 100 100" className={className} style={style} aria-hidden="true">
    {/* orelles */}
    <circle cx="20" cy="55" r="14" fill="currentColor" />
    <circle cx="80" cy="55" r="14" fill="currentColor" />
    {/* cap */}
    <path
      d="M50 14c4-6 9-6 9 0 0 4-3 7-3 7 11 4 19 14 19 27 0 17-11 30-25 30S25 65 25 48c0-13 8-23 19-27 0 0-3-3-3-7 0-6 5-6 9 0Z"
      fill="currentColor"
    />
  </svg>
);

// Petjada per al camí del bosc
export const Footprint = ({ className = "", style }) => (
  <svg viewBox="0 0 24 24" className={className} style={style} aria-hidden="true">
    <ellipse cx="12" cy="15" rx="6" ry="7.5" fill="currentColor" />
    <circle cx="6" cy="6" r="2.2" fill="currentColor" />
    <circle cx="11" cy="4" r="2.2" fill="currentColor" />
    <circle cx="16" cy="5" r="2.2" fill="currentColor" />
    <circle cx="20" cy="8.5" r="2" fill="currentColor" />
  </svg>
);
